var map = {
	"./nn/dictation/diktat-12.mp3": 138,
	"./nn/dictation/diktat-13.mp3": 139,
	"./nn/dictation/diktat-15.mp3": 140,
	"./nn/dictation/diktat-16.mp3": 141,
	"./nn/dictation/diktat-17.mp3": 142,
	"./nn/dictation/diktat-19.mp3": 143,
	"./nn/dictation/diktat-21.mp3": 144,
	"./nn/dictation/diktat-24.mp3": 145,
	"./nn/dictation/diktat-28.mp3": 146,
	"./nn/dictation/diktat-35.mp3": 147,
	"./nn/dictation/diktat-36.mp3": 148,
	"./nn/dictation/diktat-38.mp3": 149,
	"./nn/dictation/diktat-39.mp3": 150,
	"./nn/dictation/diktat-intro.mp3": 429,
	"./nn/intros/New-intro-nonword-NN.mp3": 191,
	"./nn/intros/NonWOrdInstruction.mp3": 925,
	"./nn/intros/NonWord-Intro-AFTER-trail-exercises.mp3": 335,
	"./nn/intros/SM_Intro-AFTER-trial.mp3": 430,
	"./nn/intros/letterKnowledge-intro.mp3": 431,
	"./nn/intros/nn-Arbeidsminne-instruction-WORD.mp3": 424,
	"./nn/intros/oneMinute-intro.mp3": 432,
	"./nn/intros/pd-intro.mp3": 433,
	"./nn/intros/phonemeIsolation-klarte-oppgaver.mp3": 428,
	"./nn/intros/phonemeIsolation-starter-intro.mp3": 427,
	"./nn/intros/setningsminne-intro.mp3": 434,
	"./nn/intros/testen-er-ferdig.mp3": 926,
	"./nn/intros/workingmemory-numbers-intro.mp3": 361,
	"./nn/intros/workingmemory-words-intro.mp3": 927,
	"./nn/intros/workingmemory-words-intronn.mp3": 422,
	"./nn/nonwordRepetition/adult/test/1.mp3": 316,
	"./nn/nonwordRepetition/adult/test/10.mp3": 324,
	"./nn/nonwordRepetition/adult/test/11.mp3": 676,
	"./nn/nonwordRepetition/adult/test/12.mp3": 325,
	"./nn/nonwordRepetition/adult/test/13.mp3": 326,
	"./nn/nonwordRepetition/adult/test/14.mp3": 677,
	"./nn/nonwordRepetition/adult/test/15.mp3": 678,
	"./nn/nonwordRepetition/adult/test/16.mp3": 327,
	"./nn/nonwordRepetition/adult/test/2.mp3": 675,
	"./nn/nonwordRepetition/adult/test/3.mp3": 317,
	"./nn/nonwordRepetition/adult/test/4.mp3": 318,
	"./nn/nonwordRepetition/adult/test/5.mp3": 319,
	"./nn/nonwordRepetition/adult/test/6.mp3": 320,
	"./nn/nonwordRepetition/adult/test/7.mp3": 321,
	"./nn/nonwordRepetition/adult/test/8.mp3": 322,
	"./nn/nonwordRepetition/adult/test/9.mp3": 323,
	"./nn/nonwordRepetition/adult/trial/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 928,
	"./nn/nonwordRepetition/adult/trial/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 929,
	"./nn/nonwordRepetition/adult/trial/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 930,
	"./nn/nonwordRepetition/adult/trial/Instructions for all tests/Intro-after-trail.mp3": 931,
	"./nn/nonwordRepetition/adult/trial/Instructions for all tests/Intro-nonord-NN.mp3": 932,
	"./nn/nonwordRepetition/adult/trial/exersices/ALL TRIAL if-correct.mp3": 933,
	"./nn/nonwordRepetition/adult/trial/exersices/ALL-trialrepeat-the-word.mp3": 934,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2-if-wrong.mp3": 935,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2-if-wrongafter-10-sec.mp3": 936,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2-unansweredafter-10-sec.mp3": 937,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 2.mp3": 938,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3-after-10-sek-if-wrong.mp3": 939,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3-if-wrong.mp3": 940,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3-unanswered-after-10-sec.mp3": 941,
	"./nn/nonwordRepetition/adult/trial/exersices/TRIAL 3.mp3": 942,
	"./nn/nonwordRepetition/adult/trial/exersices/Trial1-if-correct.mp3": 328,
	"./nn/nonwordRepetition/adult/trial/exersices/Trial1-if-wrong.mp3": 329,
	"./nn/nonwordRepetition/adult/trial/exersices/Trial1.mp3": 943,
	"./nn/nonwordRepetition/adult/trial/exersices/trial1-after-10-sek-if-unanswered.mp3": 330,
	"./nn/nonwordRepetition/adult/trial/exersices/trial1-after-10-sek-if-wrong.mp3": 331,
	"./nn/nonwordRepetition/child/test/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 944,
	"./nn/nonwordRepetition/child/test/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 945,
	"./nn/nonwordRepetition/child/test/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 946,
	"./nn/nonwordRepetition/child/test/Repeat-the-word-kan-du-seie-orde.mp3": 947,
	"./nn/nonwordRepetition/child/test/nonord c 1.mp3": 251,
	"./nn/nonwordRepetition/child/test/nonord-c-10.mp3": 660,
	"./nn/nonwordRepetition/child/test/nonord-c-11.mp3": 661,
	"./nn/nonwordRepetition/child/test/nonord-c-12.mp3": 257,
	"./nn/nonwordRepetition/child/test/nonord-c-13.mp3": 258,
	"./nn/nonwordRepetition/child/test/nonord-c-14.mp3": 662,
	"./nn/nonwordRepetition/child/test/nonord-c-15.mp3": 259,
	"./nn/nonwordRepetition/child/test/nonord-c-16.mp3": 260,
	"./nn/nonwordRepetition/child/test/nonord-c-17.mp3": 948,
	"./nn/nonwordRepetition/child/test/nonord-c-2.mp3": 657,
	"./nn/nonwordRepetition/child/test/nonord-c-3.mp3": 252,
	"./nn/nonwordRepetition/child/test/nonord-c-4.mp3": 658,
	"./nn/nonwordRepetition/child/test/nonord-c-5.mp3": 253,
	"./nn/nonwordRepetition/child/test/nonord-c-6.mp3": 659,
	"./nn/nonwordRepetition/child/test/nonord-c-7.mp3": 254,
	"./nn/nonwordRepetition/child/test/nonord-c-8.mp3": 255,
	"./nn/nonwordRepetition/child/test/nonord-c-9.mp3": 256,
	"./nn/nonwordRepetition/child/trial/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 949,
	"./nn/nonwordRepetition/child/trial/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 950,
	"./nn/nonwordRepetition/child/trial/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 951,
	"./nn/nonwordRepetition/child/trial/Intro-after-trial.mp3": 267,
	"./nn/nonwordRepetition/child/trial/Repeat-the-word-kan-du-seie-orde.mp3": 106,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL if-correct.mp3": 263,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL-1-if-wrong-after-10-sec.mp3": 265,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL-1-if-wrong.mp3": 264,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL-1-unanswered-10-sec.mp3": 266,
	"./nn/nonwordRepetition/child/trial/exersices/TRIAL1.mp3": 952,
	"./nn/nonwordRepetition/child/trial/exersices/nn-Nonord-C-trial-Kap.mp3": 262,
	"./nn/nonwordRepetition/child/trial/nn-Nonord-C-Y-A-kan-du-no-gjenta.mp3": 261,
	"./nn/nonwordRepetition/distractions/1-NN-Klapp.mp3": 235,
	"./nn/nonwordRepetition/distractions/2-2-GKOLpGmm.mp3": 243,
	"./nn/nonwordRepetition/distractions/2-NN-Farger .mp3": 236,
	"./nn/nonwordRepetition/distractions/3-NN-Tall .mp3": 953,
	"./nn/nonwordRepetition/distractions/Animals.mp3": 239,
	"./nn/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3": 242,
	"./nn/nonwordRepetition/distractions/Name items with the same shape.mp3": 238,
	"./nn/nonwordRepetition/distractions/Name items.mp3": 241,
	"./nn/nonwordRepetition/distractions/items in the same color.mp3": 240,
	"./nn/nonwordRepetition/distractions/nn-Nonord-C-Y-A-trial-distractio.mp3": 333,
	"./nn/nonwordRepetition/distractions/nn-Nonord-distraction-TALL.mp3": 237,
	"./nn/nonwordRepetition/youth/test/1-Y.mp3": 284,
	"./nn/nonwordRepetition/youth/test/10-Y.mp3": 291,
	"./nn/nonwordRepetition/youth/test/11-Y.mp3": 292,
	"./nn/nonwordRepetition/youth/test/12-Y.mp3": 293,
	"./nn/nonwordRepetition/youth/test/13-Y.mp3": 669,
	"./nn/nonwordRepetition/youth/test/14-Y.mp3": 670,
	"./nn/nonwordRepetition/youth/test/15-Y.mp3": 294,
	"./nn/nonwordRepetition/youth/test/16-Y.mp3": 295,
	"./nn/nonwordRepetition/youth/test/2-Y.mp3": 285,
	"./nn/nonwordRepetition/youth/test/3-Y.mp3": 667,
	"./nn/nonwordRepetition/youth/test/4-Y.mp3": 286,
	"./nn/nonwordRepetition/youth/test/5-Y.mp3": 287,
	"./nn/nonwordRepetition/youth/test/6-Y.mp3": 668,
	"./nn/nonwordRepetition/youth/test/7-Y.mp3": 288,
	"./nn/nonwordRepetition/youth/test/8-Y.mp3": 289,
	"./nn/nonwordRepetition/youth/test/9-Y.mp3": 290,
	"./nn/nonwordRepetition/youth/test/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 954,
	"./nn/nonwordRepetition/youth/test/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 955,
	"./nn/nonwordRepetition/youth/test/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 956,
	"./nn/nonwordRepetition/youth/test/Repeat-the-wordmain-tasks.mp3": 957,
	"./nn/nonwordRepetition/youth/trial/Distractions for nonordrepetisjon (NN)/1-NN-Klapp.mp3": 958,
	"./nn/nonwordRepetition/youth/trial/Distractions for nonordrepetisjon (NN)/2-NN-Farger .mp3": 959,
	"./nn/nonwordRepetition/youth/trial/Distractions for nonordrepetisjon (NN)/3-NN-Tall .mp3": 960,
	"./nn/nonwordRepetition/youth/trial/Instructions for all tests/Intro-after-trail.mp3": 961,
	"./nn/nonwordRepetition/youth/trial/Repeat-the-wordmain-tasks.mp3": 962,
	"./nn/nonwordRepetition/youth/trial/exersices/ALL TRIAL-if-correct-after-10-sec.mp3": 963,
	"./nn/nonwordRepetition/youth/trial/exersices/ALL-trialrepeat-the-word.mp3": 964,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2-if-wrong.mp3": 965,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2-if-wrongafter-10-sec.mp3": 966,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2-unansweredafter-10-sec.mp3": 967,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 2.mp3": 968,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3 unanswered-after-10-sec.mp3": 969,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3-if-wrong-after-10-sec.mp3": 970,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3-if-wrong.mp3": 971,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL 3.mp3": 972,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1-answered-after-10-sec.mp3": 298,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1-if-wrong-after-10-sec.mp3": 299,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1.mp3": 973,
	"./nn/nonwordRepetition/youth/trial/exersices/TRIAL1if-wrong.mp3": 297,
	"./nn/nonwordRepetition/youth/trial/exersices/if-correct.mp3": 296,
	"./nn/nonwordRepetition/youth/trial/exersices/nn-Nonord-Y-A-trial-Skjofenal.mp3": 44,
	"./nn/phonemeDeletion/brev-b.mp3": 435,
	"./nn/phonemeDeletion/brev.mp3": 974,
	"./nn/phonemeDeletion/broed-b.mp3": 436,
	"./nn/phonemeDeletion/bru-r.mp3": 437,
	"./nn/phonemeDeletion/bry-r.mp3": 438,
	"./nn/phonemeDeletion/drap-d.mp3": 439,
	"./nn/phonemeDeletion/foere-f.mp3": 680,
	"./nn/phonemeDeletion/foere.mp3": 681,
	"./nn/phonemeDeletion/gaas-g.mp3": 440,
	"./nn/phonemeDeletion/gris-g.mp3": 441,
	"./nn/phonemeDeletion/gris.mp3": 442,
	"./nn/phonemeDeletion/klatre-t.mp3": 443,
	"./nn/phonemeDeletion/klede-k.mp3": 444,
	"./nn/phonemeDeletion/laas-s.mp3": 445,
	"./nn/phonemeDeletion/lekse-k.mp3": 446,
	"./nn/phonemeDeletion/loff-f.mp3": 447,
	"./nn/phonemeDeletion/maal-m.mp3": 448,
	"./nn/phonemeDeletion/malt-l.mp3": 449,
	"./nn/phonemeDeletion/sel-l.mp3": 682,
	"./nn/phonemeDeletion/sel.mp3": 683,
	"./nn/phonemeDeletion/skyl-l.mp3": 450,
	"./nn/phonemeDeletion/sport-p.mp3": 451,
	"./nn/phonemeDeletion/trygg-t.mp3": 452,
	"./nn/phonemeIsolation/ends_with_e.mp3": 975,
	"./nn/phonemeIsolation/ends_with_i.mp3": 976,
	"./nn/phonemeIsolation/ends_with_k.mp3": 977,
	"./nn/phonemeIsolation/ends_with_n.mp3": 978,
	"./nn/phonemeIsolation/ends_with_o.mp3": 979,
	"./nn/phonemeIsolation/ends_with_p.mp3": 980,
	"./nn/phonemeIsolation/ends_with_r.mp3": 981,
	"./nn/phonemeIsolation/ends_with_t.mp3": 982,
	"./nn/phonemeIsolation/ends_with_u.mp3": 983,
	"./nn/phonemeIsolation/ends_with_y.mp3": 984,
	"./nn/phonemeIsolation/starts_with_b.mp3": 985,
	"./nn/phonemeIsolation/starts_with_e.mp3": 986,
	"./nn/phonemeIsolation/starts_with_g.mp3": 987,
	"./nn/phonemeIsolation/starts_with_h.mp3": 988,
	"./nn/phonemeIsolation/starts_with_i.mp3": 989,
	"./nn/phonemeIsolation/starts_with_k.mp3": 990,
	"./nn/phonemeIsolation/starts_with_l.mp3": 991,
	"./nn/phonemeIsolation/starts_with_oe.mp3": 992,
	"./nn/phonemeIsolation/starts_with_s.mp3": 993,
	"./nn/phonemeIsolation/starts_with_v.mp3": 994,
	"./nn/rapidNaming/nn-Hurtigbenevning-instruction-n.mp3": 355,
	"./nn/rapidNaming/nn-Hurtigbenevning-instruction.mp3": 995,
	"./nn/rapidNaming/rapidNaming-intro1-old.mp3": 341,
	"./nn/rapidNaming/rapidNaming-intro1.mp3": 996,
	"./nn/rapidNaming/rapidNaming-intro2-old.mp3": 342,
	"./nn/rapidNaming/rapidNaming-intro2.mp3": 352,
	"./nn/rapidNaming/rapidNaming-intro3-old.mp3": 343,
	"./nn/rapidNaming/rapidNaming-intro3.mp3": 353,
	"./nn/rapidNaming/rapidNaming-intro4-old.mp3": 344,
	"./nn/rapidNaming/rapidNaming-intro4.mp3": 354,
	"./nn/rapidNaming/rapidNaming-intro5.mp3": 345,
	"./nn/rapidNaming/rapidNaming-norming-intro1.mp3": 351,
	"./nn/sentencememory/adult/test/A1.mp3": 453,
	"./nn/sentencememory/adult/test/A10.mp3": 454,
	"./nn/sentencememory/adult/test/A11.mp3": 684,
	"./nn/sentencememory/adult/test/A12.mp3": 455,
	"./nn/sentencememory/adult/test/A13.mp3": 456,
	"./nn/sentencememory/adult/test/A14.mp3": 457,
	"./nn/sentencememory/adult/test/A15.mp3": 458,
	"./nn/sentencememory/adult/test/A2.mp3": 685,
	"./nn/sentencememory/adult/test/A3.mp3": 459,
	"./nn/sentencememory/adult/test/A4.mp3": 460,
	"./nn/sentencememory/adult/test/A5.mp3": 461,
	"./nn/sentencememory/adult/test/A6.mp3": 462,
	"./nn/sentencememory/adult/test/A7.mp3": 463,
	"./nn/sentencememory/adult/test/A8.mp3": 686,
	"./nn/sentencememory/adult/test/A9.mp3": 464,
	"./nn/sentencememory/adult/trial/SM-ST1-TRIAL-if-correct.mp3": 151,
	"./nn/sentencememory/adult/trial/TASK 1 if-wrong.mp3": 152,
	"./nn/sentencememory/adult/trial/TASK 1.mp3": 465,
	"./nn/sentencememory/adult/trial/TASK 2 if wrong.mp3": 687,
	"./nn/sentencememory/adult/trial/TASK 2.mp3": 688,
	"./nn/sentencememory/child/test/grade2-4/ST1.mp3": 689,
	"./nn/sentencememory/child/test/grade2-4/ST10.mp3": 466,
	"./nn/sentencememory/child/test/grade2-4/ST11.mp3": 467,
	"./nn/sentencememory/child/test/grade2-4/ST12.mp3": 468,
	"./nn/sentencememory/child/test/grade2-4/ST2.mp3": 469,
	"./nn/sentencememory/child/test/grade2-4/ST3.mp3": 470,
	"./nn/sentencememory/child/test/grade2-4/ST4.mp3": 471,
	"./nn/sentencememory/child/test/grade2-4/ST5.mp3": 472,
	"./nn/sentencememory/child/test/grade2-4/ST6.mp3": 473,
	"./nn/sentencememory/child/test/grade2-4/ST7.mp3": 690,
	"./nn/sentencememory/child/test/grade2-4/ST8.mp3": 474,
	"./nn/sentencememory/child/test/grade2-4/ST9.mp3": 475,
	"./nn/sentencememory/child/test/grade5-7/MT1.mp3": 476,
	"./nn/sentencememory/child/test/grade5-7/MT10.mp3": 477,
	"./nn/sentencememory/child/test/grade5-7/MT11.mp3": 478,
	"./nn/sentencememory/child/test/grade5-7/MT12.mp3": 479,
	"./nn/sentencememory/child/test/grade5-7/MT2.mp3": 691,
	"./nn/sentencememory/child/test/grade5-7/MT3.mp3": 480,
	"./nn/sentencememory/child/test/grade5-7/MT4.mp3": 481,
	"./nn/sentencememory/child/test/grade5-7/MT5.mp3": 692,
	"./nn/sentencememory/child/test/grade5-7/MT6.mp3": 482,
	"./nn/sentencememory/child/test/grade5-7/MT7.mp3": 483,
	"./nn/sentencememory/child/test/grade5-7/MT8.mp3": 484,
	"./nn/sentencememory/child/test/grade5-7/MT9.mp3": 485,
	"./nn/sentencememory/child/trial/grade2-4/Instructions-after-trail.mp3": 997,
	"./nn/sentencememory/child/trial/grade2-4/Instructions.mp3": 998,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3": 64,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3": 486,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL.mp3": 487,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3": 693,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3": 132,
	"./nn/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL.mp3": 694,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3": 65,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3": 66,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL.mp3": 488,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-correct.mp3": 695,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-wrong.mp3": 696,
	"./nn/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL.mp3": 697,
	"./nn/sentencememory/youth/test/Y1.mp3": 489,
	"./nn/sentencememory/youth/test/Y10.mp3": 698,
	"./nn/sentencememory/youth/test/Y11.mp3": 490,
	"./nn/sentencememory/youth/test/Y12.mp3": 491,
	"./nn/sentencememory/youth/test/Y13.mp3": 492,
	"./nn/sentencememory/youth/test/Y14.mp3": 493,
	"./nn/sentencememory/youth/test/Y15.mp3": 494,
	"./nn/sentencememory/youth/test/Y2.mp3": 495,
	"./nn/sentencememory/youth/test/Y3.mp3": 496,
	"./nn/sentencememory/youth/test/Y4.mp3": 497,
	"./nn/sentencememory/youth/test/Y5.mp3": 699,
	"./nn/sentencememory/youth/test/Y6.mp3": 498,
	"./nn/sentencememory/youth/test/Y7.mp3": 499,
	"./nn/sentencememory/youth/test/Y8.mp3": 700,
	"./nn/sentencememory/youth/test/Y9.mp3": 500,
	"./nn/sentencememory/youth/trail/SM-ST1-TRIAL-if-correct.mp3": 153,
	"./nn/sentencememory/youth/trail/TRIAL 1-if-wrong.mp3": 154,
	"./nn/sentencememory/youth/trail/TRIAL 1.mp3": 501,
	"./nn/sentencememory/youth/trail/TRIAL 2-if-wrong.mp3": 701,
	"./nn/sentencememory/youth/trail/TRIAL 2.mp3": 702,
	"./nn/spoonerism/correct-1.mp3": 502,
	"./nn/spoonerism/correct-2.mp3": 703,
	"./nn/spoonerism/correct-3.mp3": 704,
	"./nn/spoonerism/incorrect-1.mp3": 503,
	"./nn/spoonerism/incorrect-2.mp3": 705,
	"./nn/spoonerism/incorrect-3.mp3": 706,
	"./nn/spoonerism/intro-end.mp3": 67,
	"./nn/spoonerism/intro.mp3": 68,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-1.mp3": 504,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-10.mp3": 505,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-11.mp3": 506,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-12.mp3": 507,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-13.mp3": 508,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-14.mp3": 509,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-15.mp3": 155,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-16.mp3": 510,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-17.mp3": 511,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-18.mp3": 512,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-2.mp3": 513,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-3.mp3": 707,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-4.mp3": 514,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-5.mp3": 515,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-6.mp3": 708,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-7.mp3": 516,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-8.mp3": 709,
	"./nn/spoonerism/norming/grade6-7/test/Spoonerism-MT-9.mp3": 710,
	"./nn/spoonerism/norming/grade6-7/trail/Instructions-after-trial.mp3": 69,
	"./nn/spoonerism/norming/grade6-7/trail/Instructions.mp3": 517,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-both-correct.mp3": 518,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-both-wrong.mp3": 519,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1 if-one-correct.mp3": 520,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 1.mp3": 521,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-both-correct.mp3": 711,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-both-wrong.mp3": 712,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2 if-one-correct.mp3": 713,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 2.mp3": 714,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-both-correct.mp3": 715,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-both-wrong.mp3": 716,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3 if-one-correct.mp3": 717,
	"./nn/spoonerism/norming/grade6-7/trail/TRIAL 3.mp3": 718,
	"./nn/spoonerism/norming/grade6-7/trail/nn-spoonerism-Cinstructions.mp3": 522,
	"./nn/spoonerism/proveoppgave-1.mp3": 523,
	"./nn/spoonerism/proveoppgave-2.mp3": 719,
	"./nn/spoonerism/proveoppgave-3.mp3": 720,
	"./nn/spoonerism/spoonerism-task (1).mp3": 524,
	"./nn/spoonerism/spoonerism-task (10).mp3": 721,
	"./nn/spoonerism/spoonerism-task (11).mp3": 525,
	"./nn/spoonerism/spoonerism-task (2).mp3": 526,
	"./nn/spoonerism/spoonerism-task (3).mp3": 722,
	"./nn/spoonerism/spoonerism-task (4).mp3": 723,
	"./nn/spoonerism/spoonerism-task (5).mp3": 724,
	"./nn/spoonerism/spoonerism-task (6).mp3": 527,
	"./nn/spoonerism/spoonerism-task (7).mp3": 725,
	"./nn/spoonerism/spoonerism-task (8).mp3": 726,
	"./nn/spoonerism/spoonerism-task (9).mp3": 528,
	"./nn/spoonerism/unk-spoonerism-task ().mp3": 999,
	"./nn/workingmemory_numbers/nn-Arbeidsminne-No-kjem-det-flei-tal.mp3": 408,
	"./nn/workingmemory_numbers/wmTrial-numbers-1.mp3": 136,
	"./nn/workingmemory_numbers/wmTrial-numbers-2.mp3": 395,
	"./nn/workingmemory_numbers/workingmemory-numbers-1.mp3": 396,
	"./nn/workingmemory_numbers/workingmemory-numbers-10.mp3": 405,
	"./nn/workingmemory_numbers/workingmemory-numbers-11.mp3": 406,
	"./nn/workingmemory_numbers/workingmemory-numbers-12.mp3": 407,
	"./nn/workingmemory_numbers/workingmemory-numbers-2.mp3": 397,
	"./nn/workingmemory_numbers/workingmemory-numbers-3.mp3": 398,
	"./nn/workingmemory_numbers/workingmemory-numbers-4.mp3": 399,
	"./nn/workingmemory_numbers/workingmemory-numbers-5.mp3": 400,
	"./nn/workingmemory_numbers/workingmemory-numbers-6.mp3": 401,
	"./nn/workingmemory_numbers/workingmemory-numbers-7.mp3": 402,
	"./nn/workingmemory_numbers/workingmemory-numbers-8.mp3": 403,
	"./nn/workingmemory_numbers/workingmemory-numbers-9.mp3": 404,
	"./nn/workingmemory_words/nn-Arbeidsminne-No-kjem-det-flei-ord.mp3": 421,
	"./nn/workingmemory_words/stop.mp3": 1000,
	"./nn/workingmemory_words/wmTrial-words-1.mp3": 393,
	"./nn/workingmemory_words/wmTrial-words-2.mp3": 394,
	"./nn/workingmemory_words/workingmemory-words-1.mp3": 409,
	"./nn/workingmemory_words/workingmemory-words-10.mp3": 418,
	"./nn/workingmemory_words/workingmemory-words-11.mp3": 419,
	"./nn/workingmemory_words/workingmemory-words-12.mp3": 420,
	"./nn/workingmemory_words/workingmemory-words-2.mp3": 410,
	"./nn/workingmemory_words/workingmemory-words-3.mp3": 411,
	"./nn/workingmemory_words/workingmemory-words-4.mp3": 412,
	"./nn/workingmemory_words/workingmemory-words-5.mp3": 413,
	"./nn/workingmemory_words/workingmemory-words-6.mp3": 414,
	"./nn/workingmemory_words/workingmemory-words-7.mp3": 415,
	"./nn/workingmemory_words/workingmemory-words-8.mp3": 416,
	"./nn/workingmemory_words/workingmemory-words-9.mp3": 417,
	"./no/dictation/diktat-0.mp3": 70,
	"./no/dictation/diktat-1.mp3": 71,
	"./no/dictation/diktat-10.mp3": 72,
	"./no/dictation/diktat-11.mp3": 73,
	"./no/dictation/diktat-12.mp3": 156,
	"./no/dictation/diktat-13.mp3": 157,
	"./no/dictation/diktat-14.mp3": 74,
	"./no/dictation/diktat-15.mp3": 158,
	"./no/dictation/diktat-16.mp3": 159,
	"./no/dictation/diktat-17.mp3": 160,
	"./no/dictation/diktat-18.mp3": 75,
	"./no/dictation/diktat-19.mp3": 161,
	"./no/dictation/diktat-2.mp3": 76,
	"./no/dictation/diktat-20.mp3": 77,
	"./no/dictation/diktat-21.mp3": 162,
	"./no/dictation/diktat-22.mp3": 78,
	"./no/dictation/diktat-23.mp3": 79,
	"./no/dictation/diktat-24.mp3": 163,
	"./no/dictation/diktat-25.mp3": 80,
	"./no/dictation/diktat-26.mp3": 81,
	"./no/dictation/diktat-27.mp3": 82,
	"./no/dictation/diktat-28.mp3": 164,
	"./no/dictation/diktat-29.mp3": 83,
	"./no/dictation/diktat-3.mp3": 84,
	"./no/dictation/diktat-30.mp3": 85,
	"./no/dictation/diktat-31.mp3": 86,
	"./no/dictation/diktat-32.mp3": 87,
	"./no/dictation/diktat-33.mp3": 88,
	"./no/dictation/diktat-34.mp3": 89,
	"./no/dictation/diktat-35.mp3": 165,
	"./no/dictation/diktat-36.mp3": 166,
	"./no/dictation/diktat-37.mp3": 90,
	"./no/dictation/diktat-38.mp3": 167,
	"./no/dictation/diktat-39.mp3": 168,
	"./no/dictation/diktat-4.mp3": 91,
	"./no/dictation/diktat-5.mp3": 92,
	"./no/dictation/diktat-6.mp3": 93,
	"./no/dictation/diktat-7.mp3": 94,
	"./no/dictation/diktat-8.mp3": 95,
	"./no/dictation/diktat-9.mp3": 96,
	"./no/dictation/diktat-intro.mp3": 529,
	"./no/intros/Arbeidsminne-introduction-WORDS.mp3": 423,
	"./no/intros/New-intro-nonword-BM.mp3": 190,
	"./no/intros/NonWOrdInstruction.mp3": 1001,
	"./no/intros/NonWord-Intro-AFTER-trail-exercises.mp3": 334,
	"./no/intros/SM_Intro-AFTER-trial.mp3": 530,
	"./no/intros/letterKnowledge-intro.mp3": 531,
	"./no/intros/oneMinute-intro.mp3": 532,
	"./no/intros/pd-intro.mp3": 533,
	"./no/intros/phonemeIsolation-klarte-oppgaver.mp3": 426,
	"./no/intros/phonemeIsolation-starter-intro.mp3": 425,
	"./no/intros/setningsminne-intro.mp3": 534,
	"./no/intros/testen-er-ferdig.mp3": 356,
	"./no/intros/workingmemory-numbers-intro.mp3": 360,
	"./no/intros/workingmemory-words-intro.mp3": 1002,
	"./no/intros/workingmemory-words-introno.mp3": 137,
	"./no/nonwordRepetition/adult/test/1.mp3": 300,
	"./no/nonwordRepetition/adult/test/10.mp3": 308,
	"./no/nonwordRepetition/adult/test/11.mp3": 672,
	"./no/nonwordRepetition/adult/test/12.mp3": 309,
	"./no/nonwordRepetition/adult/test/13.mp3": 310,
	"./no/nonwordRepetition/adult/test/14.mp3": 673,
	"./no/nonwordRepetition/adult/test/15.mp3": 674,
	"./no/nonwordRepetition/adult/test/16.mp3": 311,
	"./no/nonwordRepetition/adult/test/2.mp3": 671,
	"./no/nonwordRepetition/adult/test/3.mp3": 301,
	"./no/nonwordRepetition/adult/test/4.mp3": 302,
	"./no/nonwordRepetition/adult/test/5.mp3": 303,
	"./no/nonwordRepetition/adult/test/6.mp3": 304,
	"./no/nonwordRepetition/adult/test/7.mp3": 305,
	"./no/nonwordRepetition/adult/test/8.mp3": 306,
	"./no/nonwordRepetition/adult/test/9.mp3": 307,
	"./no/nonwordRepetition/adult/test/Si-ordet-en-gang-til.mp3": 1003,
	"./no/nonwordRepetition/adult/trial/Si-ordet-en-gang-til.mp3": 1004,
	"./no/nonwordRepetition/adult/trial/Trial 1(3)-kan-du-si-ordet-en-gang-til2.mp3": 1005,
	"./no/nonwordRepetition/adult/trial/Trial1-if-correct.mp3": 312,
	"./no/nonwordRepetition/adult/trial/Trial1-if-wrong.mp3": 313,
	"./no/nonwordRepetition/adult/trial/Trial1.mp3": 1006,
	"./no/nonwordRepetition/adult/trial/trial 1(3)-after-10-sek-if-correct.mp3": 1007,
	"./no/nonwordRepetition/adult/trial/trial1-after-10-sek-if-unanswered.mp3": 314,
	"./no/nonwordRepetition/adult/trial/trial1-after-10-sek-if-wrong.mp3": 315,
	"./no/nonwordRepetition/child/test/Si-ordet-en-gang-til.mp3": 244,
	"./no/nonwordRepetition/child/test/nonord-c-1.mp3": 216,
	"./no/nonwordRepetition/child/test/nonord-c-10.mp3": 654,
	"./no/nonwordRepetition/child/test/nonord-c-11.mp3": 655,
	"./no/nonwordRepetition/child/test/nonord-c-12.mp3": 222,
	"./no/nonwordRepetition/child/test/nonord-c-13.mp3": 223,
	"./no/nonwordRepetition/child/test/nonord-c-14.mp3": 656,
	"./no/nonwordRepetition/child/test/nonord-c-15.mp3": 224,
	"./no/nonwordRepetition/child/test/nonord-c-16.mp3": 225,
	"./no/nonwordRepetition/child/test/nonord-c-17.mp3": 1008,
	"./no/nonwordRepetition/child/test/nonord-c-2.mp3": 651,
	"./no/nonwordRepetition/child/test/nonord-c-3.mp3": 217,
	"./no/nonwordRepetition/child/test/nonord-c-4.mp3": 652,
	"./no/nonwordRepetition/child/test/nonord-c-5.mp3": 218,
	"./no/nonwordRepetition/child/test/nonord-c-6.mp3": 653,
	"./no/nonwordRepetition/child/test/nonord-c-7.mp3": 219,
	"./no/nonwordRepetition/child/test/nonord-c-8.mp3": 220,
	"./no/nonwordRepetition/child/test/nonord-c-9.mp3": 221,
	"./no/nonwordRepetition/child/trial/Intro-AFTER-trail-exercises.mp3": 250,
	"./no/nonwordRepetition/child/trial/Nonord-C-Y-A-trial-kan-du-gjenta.mp3": 105,
	"./no/nonwordRepetition/child/trial/Nonord-C-trial-Kap.mp3": 245,
	"./no/nonwordRepetition/child/trial/Si-ordet-en-gang-til.mp3": 1009,
	"./no/nonwordRepetition/child/trial/TRIAL1-after-10-sek-if-wrong.mp3": 249,
	"./no/nonwordRepetition/child/trial/trial-1-after10sec-if-they-dont-rememeber.mp3": 248,
	"./no/nonwordRepetition/child/trial/trial1-if-correct.mp3": 246,
	"./no/nonwordRepetition/child/trial/trial1-if-wrong.mp3": 247,
	"./no/nonwordRepetition/child/trial/trial1.mp3": 1010,
	"./no/nonwordRepetition/distractions/1-4-adp9Bwg9.mp3": 234,
	"./no/nonwordRepetition/distractions/1-Klapp (1).mp3": 226,
	"./no/nonwordRepetition/distractions/2-Fargene (1).mp3": 227,
	"./no/nonwordRepetition/distractions/3-Tall (1).mp3": 1011,
	"./no/nonwordRepetition/distractions/4 things that has the same shape.mp3": 229,
	"./no/nonwordRepetition/distractions/Animals.mp3": 230,
	"./no/nonwordRepetition/distractions/Items in same color.mp3": 231,
	"./no/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3": 233,
	"./no/nonwordRepetition/distractions/Name items.mp3": 232,
	"./no/nonwordRepetition/distractions/Nonord-C-Y-A-trial-distration-ta.mp3": 332,
	"./no/nonwordRepetition/distractions/Nonord-Distraction-TALL.mp3": 228,
	"./no/nonwordRepetition/youth/test/1-Y.mp3": 268,
	"./no/nonwordRepetition/youth/test/10-Y.mp3": 275,
	"./no/nonwordRepetition/youth/test/11-Y.mp3": 276,
	"./no/nonwordRepetition/youth/test/12-Y.mp3": 277,
	"./no/nonwordRepetition/youth/test/13-Y.mp3": 665,
	"./no/nonwordRepetition/youth/test/14-Y.mp3": 666,
	"./no/nonwordRepetition/youth/test/15-Y.mp3": 278,
	"./no/nonwordRepetition/youth/test/16-Y.mp3": 279,
	"./no/nonwordRepetition/youth/test/2-Y.mp3": 269,
	"./no/nonwordRepetition/youth/test/3-Y.mp3": 663,
	"./no/nonwordRepetition/youth/test/4-Y.mp3": 270,
	"./no/nonwordRepetition/youth/test/5-Y.mp3": 271,
	"./no/nonwordRepetition/youth/test/6-Y.mp3": 664,
	"./no/nonwordRepetition/youth/test/7-Y.mp3": 272,
	"./no/nonwordRepetition/youth/test/8-Y.mp3": 273,
	"./no/nonwordRepetition/youth/test/9-Y.mp3": 274,
	"./no/nonwordRepetition/youth/test/Si-ordet-en-gang-til.mp3": 1012,
	"./no/nonwordRepetition/youth/trial/Intro-AFTER-trialexercises.mp3": 1013,
	"./no/nonwordRepetition/youth/trial/Nonord-Y-A-trial-Skjofenal.mp3": 43,
	"./no/nonwordRepetition/youth/trial/Si-ordet-en-gang-til.mp3": 1014,
	"./no/nonwordRepetition/youth/trial/Trial1-if-correct.mp3": 280,
	"./no/nonwordRepetition/youth/trial/Trial1-if-wrong.mp3": 281,
	"./no/nonwordRepetition/youth/trial/Trial1-kan-du-si-ordet-en-gang-til2.mp3": 1015,
	"./no/nonwordRepetition/youth/trial/Trial1.mp3": 1016,
	"./no/nonwordRepetition/youth/trial/trial1-after-10-sek-if-correct.mp3": 1017,
	"./no/nonwordRepetition/youth/trial/trial1-after-10-sek-if-unanswered.mp3": 282,
	"./no/nonwordRepetition/youth/trial/trial1-after-10-sek-if-wrong.mp3": 283,
	"./no/phonemeDeletion/brev-b.mp3": 535,
	"./no/phonemeDeletion/brev.mp3": 1018,
	"./no/phonemeDeletion/bro-r.mp3": 536,
	"./no/phonemeDeletion/bro.mp3": 1019,
	"./no/phonemeDeletion/broed-b.mp3": 537,
	"./no/phonemeDeletion/broed.mp3": 1020,
	"./no/phonemeDeletion/brus-b.mp3": 1021,
	"./no/phonemeDeletion/bry-r.mp3": 538,
	"./no/phonemeDeletion/bry.mp3": 1022,
	"./no/phonemeDeletion/dansk-k.mp3": 1023,
	"./no/phonemeDeletion/drap-d.mp3": 539,
	"./no/phonemeDeletion/drap.mp3": 1024,
	"./no/phonemeDeletion/film-m.mp3": 1025,
	"./no/phonemeDeletion/foere-f.mp3": 727,
	"./no/phonemeDeletion/foere.mp3": 728,
	"./no/phonemeDeletion/gaas-g.mp3": 540,
	"./no/phonemeDeletion/gaas.mp3": 1026,
	"./no/phonemeDeletion/gris-g.mp3": 541,
	"./no/phonemeDeletion/gris.mp3": 542,
	"./no/phonemeDeletion/hans-s.mp3": 1027,
	"./no/phonemeDeletion/helst-l.mp3": 1028,
	"./no/phonemeDeletion/klaer-k.mp3": 543,
	"./no/phonemeDeletion/klaer.mp3": 1029,
	"./no/phonemeDeletion/klart-t.mp3": 1030,
	"./no/phonemeDeletion/klatre-t.mp3": 544,
	"./no/phonemeDeletion/klatre.mp3": 1031,
	"./no/phonemeDeletion/laas-s.mp3": 545,
	"./no/phonemeDeletion/laas.mp3": 1032,
	"./no/phonemeDeletion/lekse-k.mp3": 546,
	"./no/phonemeDeletion/lekse.mp3": 1033,
	"./no/phonemeDeletion/loff-f.mp3": 547,
	"./no/phonemeDeletion/loff.mp3": 1034,
	"./no/phonemeDeletion/maal-m.mp3": 548,
	"./no/phonemeDeletion/malt-l.mp3": 549,
	"./no/phonemeDeletion/malt.mp3": 1035,
	"./no/phonemeDeletion/mars-r.mp3": 1036,
	"./no/phonemeDeletion/pris-p.mp3": 1037,
	"./no/phonemeDeletion/ris-r.mp3": 1038,
	"./no/phonemeDeletion/sel-l.mp3": 729,
	"./no/phonemeDeletion/sel.mp3": 730,
	"./no/phonemeDeletion/ser-r.mp3": 1039,
	"./no/phonemeDeletion/skyll-l.mp3": 550,
	"./no/phonemeDeletion/skyll.mp3": 1040,
	"./no/phonemeDeletion/spoer-p.mp3": 1041,
	"./no/phonemeDeletion/sport-p.mp3": 551,
	"./no/phonemeDeletion/sport.mp3": 1042,
	"./no/phonemeDeletion/stoev-s.mp3": 1043,
	"./no/phonemeDeletion/tap-p.mp3": 1044,
	"./no/phonemeDeletion/tekst-k.mp3": 1045,
	"./no/phonemeDeletion/trygg-t.mp3": 552,
	"./no/phonemeDeletion/trygg.mp3": 1046,
	"./no/phonemeIsolation/ends_with_e.mp3": 1047,
	"./no/phonemeIsolation/ends_with_i.mp3": 1048,
	"./no/phonemeIsolation/ends_with_k.mp3": 1049,
	"./no/phonemeIsolation/ends_with_n.mp3": 1050,
	"./no/phonemeIsolation/ends_with_o.mp3": 1051,
	"./no/phonemeIsolation/ends_with_p.mp3": 1052,
	"./no/phonemeIsolation/ends_with_r.mp3": 1053,
	"./no/phonemeIsolation/ends_with_t.mp3": 1054,
	"./no/phonemeIsolation/ends_with_u.mp3": 1055,
	"./no/phonemeIsolation/ends_with_y.mp3": 1056,
	"./no/phonemeIsolation/starts_with_b.mp3": 1057,
	"./no/phonemeIsolation/starts_with_e.mp3": 1058,
	"./no/phonemeIsolation/starts_with_g.mp3": 1059,
	"./no/phonemeIsolation/starts_with_h.mp3": 1060,
	"./no/phonemeIsolation/starts_with_i.mp3": 1061,
	"./no/phonemeIsolation/starts_with_k.mp3": 1062,
	"./no/phonemeIsolation/starts_with_l.mp3": 1063,
	"./no/phonemeIsolation/starts_with_oe.mp3": 1064,
	"./no/phonemeIsolation/starts_with_s.mp3": 1065,
	"./no/phonemeIsolation/starts_with_v.mp3": 1066,
	"./no/rapidNaming/Hurtigbenevning-instruction-nr-2.mp3": 350,
	"./no/rapidNaming/Hurtigbenevning-instruction.mp3": 1067,
	"./no/rapidNaming/rapidNaming-intro1-old.mp3": 336,
	"./no/rapidNaming/rapidNaming-intro1.mp3": 1068,
	"./no/rapidNaming/rapidNaming-intro2-old.mp3": 337,
	"./no/rapidNaming/rapidNaming-intro2.mp3": 347,
	"./no/rapidNaming/rapidNaming-intro3-old.mp3": 338,
	"./no/rapidNaming/rapidNaming-intro3.mp3": 348,
	"./no/rapidNaming/rapidNaming-intro4-old.mp3": 339,
	"./no/rapidNaming/rapidNaming-intro4.mp3": 349,
	"./no/rapidNaming/rapidNaming-intro5.mp3": 340,
	"./no/rapidNaming/rapidNaming-norming-intro1.mp3": 346,
	"./no/sentencememory/adult/test/S-1.mp3": 553,
	"./no/sentencememory/adult/test/S-10.mp3": 554,
	"./no/sentencememory/adult/test/S-11.mp3": 731,
	"./no/sentencememory/adult/test/S-12.mp3": 555,
	"./no/sentencememory/adult/test/S-13.mp3": 556,
	"./no/sentencememory/adult/test/S-14.mp3": 557,
	"./no/sentencememory/adult/test/S-15.mp3": 558,
	"./no/sentencememory/adult/test/S-2.mp3": 732,
	"./no/sentencememory/adult/test/S-3.mp3": 559,
	"./no/sentencememory/adult/test/S-4.mp3": 560,
	"./no/sentencememory/adult/test/S-5.mp3": 561,
	"./no/sentencememory/adult/test/S-6.mp3": 562,
	"./no/sentencememory/adult/test/S-7.mp3": 563,
	"./no/sentencememory/adult/test/S-8.mp3": 733,
	"./no/sentencememory/adult/test/S-9.mp3": 564,
	"./no/sentencememory/adult/trial/A TRIAL 1-if-correct.mp3": 97,
	"./no/sentencememory/adult/trial/A TRIAL 1.mp3": 565,
	"./no/sentencememory/adult/trial/A TRIAL 2-if-correct-kopi.mp3": 734,
	"./no/sentencememory/adult/trial/A TRIAL 2-if-wrong.mp3": 735,
	"./no/sentencememory/adult/trial/A TRIAL 2.mp3": 736,
	"./no/sentencememory/adult/trial/A TRIAL1-If-wrong.mp3": 98,
	"./no/sentencememory/adult/trial/Intro-AFTER-trial.mp3": 1069,
	"./no/sentencememory/adult/trial/Intro-Y-A.mp3": 1070,
	"./no/sentencememory/child/test/grade2-4/SM-ST-1.mp3": 737,
	"./no/sentencememory/child/test/grade2-4/SM-ST-10.mp3": 566,
	"./no/sentencememory/child/test/grade2-4/SM-ST-11.mp3": 567,
	"./no/sentencememory/child/test/grade2-4/SM-ST-12 (2).mp3": 1071,
	"./no/sentencememory/child/test/grade2-4/SM-ST-12.mp3": 568,
	"./no/sentencememory/child/test/grade2-4/SM-ST-2.mp3": 569,
	"./no/sentencememory/child/test/grade2-4/SM-ST-3.mp3": 570,
	"./no/sentencememory/child/test/grade2-4/SM-ST-4.mp3": 571,
	"./no/sentencememory/child/test/grade2-4/SM-ST-5.mp3": 572,
	"./no/sentencememory/child/test/grade2-4/SM-ST-6.mp3": 573,
	"./no/sentencememory/child/test/grade2-4/SM-ST-7.mp3": 738,
	"./no/sentencememory/child/test/grade2-4/SM-ST-8.mp3": 574,
	"./no/sentencememory/child/test/grade2-4/SM-ST-9.mp3": 575,
	"./no/sentencememory/child/test/grade5-7/SM-MT-1.mp3": 576,
	"./no/sentencememory/child/test/grade5-7/SM-MT-10.mp3": 577,
	"./no/sentencememory/child/test/grade5-7/SM-MT-11.mp3": 578,
	"./no/sentencememory/child/test/grade5-7/SM-MT-12.mp3": 579,
	"./no/sentencememory/child/test/grade5-7/SM-MT-2.mp3": 739,
	"./no/sentencememory/child/test/grade5-7/SM-MT-3.mp3": 580,
	"./no/sentencememory/child/test/grade5-7/SM-MT-4.mp3": 581,
	"./no/sentencememory/child/test/grade5-7/SM-MT-5.mp3": 740,
	"./no/sentencememory/child/test/grade5-7/SM-MT-6.mp3": 582,
	"./no/sentencememory/child/test/grade5-7/SM-MT-7.mp3": 583,
	"./no/sentencememory/child/test/grade5-7/SM-MT-8.mp3": 584,
	"./no/sentencememory/child/test/grade5-7/SM-MT-9.mp3": 585,
	"./no/sentencememory/child/trial/grade2-4/SM-ST-intro (1).mp3": 1072,
	"./no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3": 99,
	"./no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3": 586,
	"./no/sentencememory/child/trial/grade2-4/SM-ST1-TRIAL.mp3": 587,
	"./no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3": 741,
	"./no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3": 133,
	"./no/sentencememory/child/trial/grade2-4/SM-ST2-TRIAL.mp3": 742,
	"./no/sentencememory/child/trial/grade5-7/SM-MT-intro-AFTER-trial-exercise.mp3": 1073,
	"./no/sentencememory/child/trial/grade5-7/SM-MT-intro-mp3.mp3": 1074,
	"./no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-correct.mp3": 169,
	"./no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL-if-wrong.mp3": 170,
	"./no/sentencememory/child/trial/grade5-7/SM-MT1-TRIAL.mp3": 588,
	"./no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-correct.mp3": 743,
	"./no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL-if-wrong.mp3": 744,
	"./no/sentencememory/child/trial/grade5-7/SM-MT2-TRIAL.mp3": 745,
	"./no/sentencememory/test/SM-ST-1.mp3": 1075,
	"./no/sentencememory/test/SM-ST-10.mp3": 1076,
	"./no/sentencememory/test/SM-ST-11.mp3": 1077,
	"./no/sentencememory/test/SM-ST-12.mp3": 1078,
	"./no/sentencememory/test/SM-ST-2.mp3": 1079,
	"./no/sentencememory/test/SM-ST-3.mp3": 1080,
	"./no/sentencememory/test/SM-ST-4.mp3": 1081,
	"./no/sentencememory/test/SM-ST-5.mp3": 1082,
	"./no/sentencememory/test/SM-ST-6.mp3": 1083,
	"./no/sentencememory/test/SM-ST-7.mp3": 1084,
	"./no/sentencememory/test/SM-ST-8.mp3": 1085,
	"./no/sentencememory/test/SM-ST-9.mp3": 1086,
	"./no/sentencememory/test/grade2-4/SM-ST-1.mp3": 1087,
	"./no/sentencememory/test/grade2-4/SM-ST-10.mp3": 1088,
	"./no/sentencememory/test/grade2-4/SM-ST-11.mp3": 1089,
	"./no/sentencememory/test/grade2-4/SM-ST-12 (2).mp3": 1090,
	"./no/sentencememory/test/grade2-4/SM-ST-12.mp3": 1091,
	"./no/sentencememory/test/grade2-4/SM-ST-2.mp3": 1092,
	"./no/sentencememory/test/grade2-4/SM-ST-3.mp3": 1093,
	"./no/sentencememory/test/grade2-4/SM-ST-4.mp3": 1094,
	"./no/sentencememory/test/grade2-4/SM-ST-5.mp3": 1095,
	"./no/sentencememory/test/grade2-4/SM-ST-6.mp3": 1096,
	"./no/sentencememory/test/grade2-4/SM-ST-7.mp3": 1097,
	"./no/sentencememory/test/grade2-4/SM-ST-8.mp3": 1098,
	"./no/sentencememory/test/grade2-4/SM-ST-9.mp3": 1099,
	"./no/sentencememory/test/grade5-7/SM-MT-1.mp3": 1100,
	"./no/sentencememory/test/grade5-7/SM-MT-10.mp3": 1101,
	"./no/sentencememory/test/grade5-7/SM-MT-11.mp3": 1102,
	"./no/sentencememory/test/grade5-7/SM-MT-12.mp3": 1103,
	"./no/sentencememory/test/grade5-7/SM-MT-2.mp3": 1104,
	"./no/sentencememory/test/grade5-7/SM-MT-3.mp3": 1105,
	"./no/sentencememory/test/grade5-7/SM-MT-4.mp3": 1106,
	"./no/sentencememory/test/grade5-7/SM-MT-5.mp3": 1107,
	"./no/sentencememory/test/grade5-7/SM-MT-6.mp3": 1108,
	"./no/sentencememory/test/grade5-7/SM-MT-7.mp3": 1109,
	"./no/sentencememory/test/grade5-7/SM-MT-8.mp3": 1110,
	"./no/sentencememory/test/grade5-7/SM-MT-9.mp3": 1111,
	"./no/sentencememory/trial/SM-ST-O1-correct.mp3": 1112,
	"./no/sentencememory/trial/SM-ST-O1-wrong.mp3": 1113,
	"./no/sentencememory/trial/SM-ST-O1.mp3": 1114,
	"./no/sentencememory/trial/SM-ST-O2-correct.mp3": 1115,
	"./no/sentencememory/trial/SM-ST-O2-wrong.mp3": 1116,
	"./no/sentencememory/trial/SM-ST-O2.mp3": 1117,
	"./no/sentencememory/trial/grade2-4/SM-ST-intro (1).mp3": 1118,
	"./no/sentencememory/trial/grade2-4/SM-ST1-TRIAL-if-correct.mp3": 1119,
	"./no/sentencememory/trial/grade2-4/SM-ST1-TRIAL-if-wrong.mp3": 1120,
	"./no/sentencememory/trial/grade2-4/SM-ST1-TRIAL.mp3": 1121,
	"./no/sentencememory/trial/grade2-4/SM-ST2-TRIAL-if-correct.mp3": 1122,
	"./no/sentencememory/trial/grade2-4/SM-ST2-TRIAL-if-wrong.mp3": 1123,
	"./no/sentencememory/trial/grade2-4/SM-ST2-TRIAL.mp3": 1124,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL1-if-correct.mp3": 1125,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL1-if-wrong.mp3": 1126,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL1.mp3": 1127,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL2-if-correct.mp3": 1128,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL2-if-worng.mp3": 1129,
	"./no/sentencememory/trial/grade5-7/SM-MT-TRIAL2.mp3": 1130,
	"./no/sentencememory/trial/grade5-7/SM-MT-intro-AFTER-trial-exercise.mp3": 1131,
	"./no/sentencememory/trial/grade5-7/SM-MT-intro-mp3.mp3": 1132,
	"./no/sentencememory/youth/test/S-1-Y.mp3": 589,
	"./no/sentencememory/youth/test/S-10-Y.mp3": 746,
	"./no/sentencememory/youth/test/S-11-Y.mp3": 590,
	"./no/sentencememory/youth/test/S-12-Y.mp3": 591,
	"./no/sentencememory/youth/test/S-13-Y.mp3": 592,
	"./no/sentencememory/youth/test/S-14-Y.mp3": 593,
	"./no/sentencememory/youth/test/S-15-Y.mp3": 594,
	"./no/sentencememory/youth/test/S-2-Y.mp3": 595,
	"./no/sentencememory/youth/test/S-3-Y.mp3": 596,
	"./no/sentencememory/youth/test/S-4-Y.mp3": 597,
	"./no/sentencememory/youth/test/S-5-Y.mp3": 747,
	"./no/sentencememory/youth/test/S-6-Y.mp3": 598,
	"./no/sentencememory/youth/test/S-7-Y.mp3": 599,
	"./no/sentencememory/youth/test/S-8-Y.mp3": 748,
	"./no/sentencememory/youth/test/S-9-Y.mp3": 600,
	"./no/sentencememory/youth/trial/Intro-AFTER-trial.mp3": 1133,
	"./no/sentencememory/youth/trial/Intro-Y-A.mp3": 1134,
	"./no/sentencememory/youth/trial/TRIAL-1-if-correct.mp3": 100,
	"./no/sentencememory/youth/trial/TRIAL-1-if-wrong.mp3": 101,
	"./no/sentencememory/youth/trial/TRIAL-1.mp3": 601,
	"./no/sentencememory/youth/trial/TRIAL-2-if-correct-kopi.mp3": 749,
	"./no/sentencememory/youth/trial/TRIAL-2-if-wrong.mp3": 750,
	"./no/sentencememory/youth/trial/TRIAL-2.mp3": 751,
	"./no/sentencememory/youth/trial/Øving-1.mp3": 1135,
	"./no/spoonerism/correct-1.mp3": 602,
	"./no/spoonerism/correct-2.mp3": 752,
	"./no/spoonerism/correct-3.mp3": 753,
	"./no/spoonerism/incorrect-1.mp3": 603,
	"./no/spoonerism/incorrect-2.mp3": 754,
	"./no/spoonerism/incorrect-3.mp3": 755,
	"./no/spoonerism/intro-end.mp3": 102,
	"./no/spoonerism/intro.mp3": 103,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-1.mp3": 604,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-10.mp3": 605,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-11.mp3": 606,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-12.mp3": 607,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-13.mp3": 608,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-14.mp3": 609,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-15.mp3": 171,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-16.mp3": 610,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-17.mp3": 611,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-18.mp3": 612,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-2.mp3": 613,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-3.mp3": 756,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-4.mp3": 614,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-5.mp3": 615,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-6.mp3": 757,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-7.mp3": 616,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-8.mp3": 758,
	"./no/spoonerism/norming/grade6-7/test/Spoonerism-MT-9.mp3": 759,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-C-instructions.mp3": 617,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRAIL1.mp3": 42,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL1-if-correct.mp3": 618,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL1-if-one-correct.mp3": 619,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-both-wrong.mp3": 187,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-correct.mp3": 188,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2-if-one-correct.mp3": 189,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL2.mp3": 1136,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3-if-both-wrong.mp3": 1137,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3-if-correct.mp3": 1138,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3-if-one-correct.mp3": 1139,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-TRIAL3.mp3": 1140,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro-AFTER-trail.mp3": 104,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro.mp3": 620,
	"./no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-trial1-if-both-wrong.mp3": 621,
	"./no/spoonerism/proveoppgave-1.mp3": 622,
	"./no/spoonerism/proveoppgave-2.mp3": 760,
	"./no/spoonerism/proveoppgave-3.mp3": 761,
	"./no/spoonerism/spoonerism-task (1).mp3": 623,
	"./no/spoonerism/spoonerism-task (10).mp3": 762,
	"./no/spoonerism/spoonerism-task (11).mp3": 624,
	"./no/spoonerism/spoonerism-task (12).mp3": 172,
	"./no/spoonerism/spoonerism-task (13).mp3": 173,
	"./no/spoonerism/spoonerism-task (14).mp3": 174,
	"./no/spoonerism/spoonerism-task (15).mp3": 175,
	"./no/spoonerism/spoonerism-task (16).mp3": 176,
	"./no/spoonerism/spoonerism-task (17).mp3": 177,
	"./no/spoonerism/spoonerism-task (18).mp3": 763,
	"./no/spoonerism/spoonerism-task (19).mp3": 178,
	"./no/spoonerism/spoonerism-task (2).mp3": 625,
	"./no/spoonerism/spoonerism-task (20).mp3": 179,
	"./no/spoonerism/spoonerism-task (3).mp3": 764,
	"./no/spoonerism/spoonerism-task (4).mp3": 765,
	"./no/spoonerism/spoonerism-task (5).mp3": 766,
	"./no/spoonerism/spoonerism-task (6).mp3": 626,
	"./no/spoonerism/spoonerism-task (7).mp3": 767,
	"./no/spoonerism/spoonerism-task (8).mp3": 768,
	"./no/spoonerism/spoonerism-task (9).mp3": 627,
	"./no/workingmemory_numbers/Arbeidminne-Na-kommer-det-flere-tal.mp3": 379,
	"./no/workingmemory_numbers/Arbeidsminne-trial-ex.mp3": 363,
	"./no/workingmemory_numbers/wmTrial-numbers-1.mp3": 362,
	"./no/workingmemory_numbers/wmTrial-numbers-2.mp3": 364,
	"./no/workingmemory_numbers/workingmemory-numbers-1.mp3": 367,
	"./no/workingmemory_numbers/workingmemory-numbers-10.mp3": 376,
	"./no/workingmemory_numbers/workingmemory-numbers-11.mp3": 377,
	"./no/workingmemory_numbers/workingmemory-numbers-12.mp3": 378,
	"./no/workingmemory_numbers/workingmemory-numbers-2.mp3": 368,
	"./no/workingmemory_numbers/workingmemory-numbers-3.mp3": 369,
	"./no/workingmemory_numbers/workingmemory-numbers-4.mp3": 370,
	"./no/workingmemory_numbers/workingmemory-numbers-5.mp3": 371,
	"./no/workingmemory_numbers/workingmemory-numbers-6.mp3": 372,
	"./no/workingmemory_numbers/workingmemory-numbers-7.mp3": 373,
	"./no/workingmemory_numbers/workingmemory-numbers-8.mp3": 374,
	"./no/workingmemory_numbers/workingmemory-numbers-9.mp3": 375,
	"./no/workingmemory_words/Arbeidsminne-Na-kommer-det-flere-ord.mp3": 392,
	"./no/workingmemory_words/wmTrial-words-1.mp3": 365,
	"./no/workingmemory_words/wmTrial-words-2.mp3": 366,
	"./no/workingmemory_words/workingmemory-words-1.mp3": 380,
	"./no/workingmemory_words/workingmemory-words-10.mp3": 389,
	"./no/workingmemory_words/workingmemory-words-11.mp3": 390,
	"./no/workingmemory_words/workingmemory-words-12.mp3": 391,
	"./no/workingmemory_words/workingmemory-words-2.mp3": 381,
	"./no/workingmemory_words/workingmemory-words-3.mp3": 382,
	"./no/workingmemory_words/workingmemory-words-4.mp3": 383,
	"./no/workingmemory_words/workingmemory-words-5.mp3": 384,
	"./no/workingmemory_words/workingmemory-words-6.mp3": 385,
	"./no/workingmemory_words/workingmemory-words-7.mp3": 386,
	"./no/workingmemory_words/workingmemory-words-8.mp3": 387,
	"./no/workingmemory_words/workingmemory-words-9.mp3": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;